import { FC } from 'react';
import { Money } from 'types';
import { formatMoney } from 'lib/formatters';

const FormattedMoney: FC<Money> = (money) => <>{formatMoney(money)}</>;

export default FormattedMoney;
